import { useNavigate } from "react-router-dom";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#ffffff", position: "relative" }}>
      {/* Top bar */}
      <nav style={{
        position: "absolute", top: 0, left: 0, right: 0, padding: "24px 40px",
        display: "flex", justifyContent: "flex-end", alignItems: "center", zIndex: 10
      }}>
        <button
          onClick={() => navigate("/login")}
          data-testid="landing-login-link"
          style={{
            background: "none", border: "1px solid rgba(0,0,0,0.2)",
            color: "#111", padding: "8px 28px", borderRadius: 6,
            fontSize: 14, fontFamily: "Manrope, sans-serif", fontWeight: 500,
            cursor: "pointer", letterSpacing: "0.02em",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => { e.target.style.background = "#111"; e.target.style.color = "#fff"; }}
          onMouseLeave={(e) => { e.target.style.background = "none"; e.target.style.color = "#111"; }}
        >
          Login
        </button>
      </nav>

      {/* Center branding */}
      <div style={{
        position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
        textAlign: "center", zIndex: 10
      }}>
        <img
          src="/toro-logo.png"
          alt="Toro Strategic"
          style={{ height: 72, margin: "0 auto", display: "block" }}
          data-testid="landing-logo"
        />
      </div>
    </div>
  );
}
